"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
var ripple_1 = require("@material/ripple");
require("../icon");
//@ts-ignore
require("../theme.ts");
var BottomNav = /** @class */ (function (_super) {
    __extends(BottomNav, _super);
    function BottomNav() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clickHandler = function (item) {
            _this.fire('itemclick', item);
            if (!item.selected) {
                _this.props.items.forEach(function (_) { return _.selected = false; });
                item.selected = true;
                _this.fire('change', item);
                _this.update(true);
            }
        };
        return _this;
    }
    BottomNav.prototype.installed = function () {
        this.shadowRoot.querySelectorAll('.ripple').forEach(function (dom) {
            new ripple_1.MDCRipple(dom);
        });
    };
    BottomNav.prototype.render = function (props) {
        var _this = this;
        return omi_1.h("div", { class: "m-bn" }, props.items.map(function (item, index) { return (omi_1.h("button", __assign({ onClick: function (_) { _this.clickHandler(item); } }, omi_1.extractClass({}, 'item', {
            'selected': item.selected
        }), (item.selected && props.selectedColor) ? { style: "color:" + props.selectedColor } : null, { tabindex: index }),
            omi_1.h("span", { class: "m-action-wrapper" },
                typeof item.icon === 'string' ? omi_1.h("i", { class: "material-icons" }, item.icon) : omi_1.h("m-icon", __assign({}, item.icon)),
                omi_1.h("span", { class: "m-action-label" }, item.label)),
            omi_1.h("span", { class: "ripple ripple-surface" }))); }));
    };
    BottomNav.css = css;
    BottomNav.defaultProps = {};
    BottomNav.propTypes = {
        selectedColor: String,
        items: Array
    };
    BottomNav = __decorate([
        omi_1.tag('m-bottom-nav')
    ], BottomNav);
    return BottomNav;
}(omi_1.WeElement));
exports.default = BottomNav;
